module.exports = __webpack_public_path__ + "stylesheets/political-landing_3f97c364950228bb3a52340f8478692d.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing/political-landing.less
// module id = Rpkd
// module chunks = 153